/** @jsxImportSource @emotion/react */
"use client";

import { Box, Typography } from "@mui/material";
import Slider from "react-slick";
import { BlogCard, BlogCardProps } from "@/components/BlogCard";
import { previewSection } from "./styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

type HomeBlogPreviewProps = {
  posts: BlogCardProps[];
};

export function HomeBlogPreview({ posts }: HomeBlogPreviewProps) {
  if (!posts || posts.length === 0) return null;

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "40px",
          arrows: false,
        },
      },
    ],
  };

  return (
    <Box css={previewSection}>
      <Typography
        variant="h2"
        color="primary.main"
        textAlign="center"
        gutterBottom
        px={2}
      >
        Famento Blog
      </Typography>

      <Slider {...sliderSettings}>
        {posts.map((post) => (
          <Box key={post.slug} px={1.5}>
            <BlogCard {...post} />
          </Box>
        ))}
      </Slider>
    </Box>
  );
}
